<ng-container *ngIf="timer">
    <span *ngIf="timer.daysLeft"> {{ timer.daysLeft }} day(s)</span> <span *ngIf="timer.hoursLeft"> {{ timer.hoursLeft }}
    hrs</span>
    <span *ngIf="timer.minutesLeft"> {{ timer.minutesLeft }} min</span> <span> {{ timer.secondsLeft }} sec</span>
</ng-container>
